<h3-settings-header
  [label]="label"
  [value]="value$ | async"
  (resetValue)="reset()"
></h3-settings-header>

<mat-slider
  [max]="config.max"
  [min]="config.min"
  [step]="config.step"
  discrete
  [displayWith]="formatValue"
>
  <input
    matSliderStartThumb
    [value]="minStore.$ | async"
    (input)="setMinValue($event)"
  />
  <input
    matSliderEndThumb
    [value]="maxStore.$ | async"
    (input)="setMaxValue($event)"
  />
</mat-slider>
